
import { Component, Vue } from "vue-property-decorator";
import WizardCart from "@/views/_components/WizardCart.vue";
import { namespace } from "vuex-class";
import CheckoutPersonalInfo from "@/views/_components/CheckoutPersonalInfo.vue";
import { Cart } from "@/types/Cart";
const { State, Action } = namespace("Root");
import supported_countries from "@/assets/supported_countries.json";
import StatusComponent from "@/components/StatusComponent.vue";
import Loader from "@/components/Loader.vue";
import app_config from "@/app_config.json";
import IUser from "@/models/protocols/IUser";
import ElementLoader from "@/components/ElementLoader.vue";
import { Country } from "@/types/Country";
import { CartItem, CartItemPaymentTerms } from "@/types/cart-item";
const { TheMask } = require("vue-the-mask");
import ValidationMessage from "@/views/_components/ValidationMessage.vue";
import UserService from "@/services/UserService";
import CartService from "@/services/CartService";
import countryService from "@/services/CountryService";
import NumericInput from "@/components/NumericInput.vue";
import RegionInput from "@/components/RegionInput.vue";
import ICountry from "@/models/protocols/ICountry";
import { BillingInfo } from "@/types/BillingInfo";
import {
  isValid,
  isExpirationDateValid,
  isSecurityCodeValid,
  getCreditCardNameByNumber,
} from "creditcard.js";
import { zipValidation } from "@/utils/zipValidation";
declare var google: any;

@Component({
  components: {
    WizardCart,
    CheckoutPersonalInfo,
    StatusComponent,
    Loader,
    TheMask,
    ElementLoader,
    ValidationMessage,
    NumericInput,
    RegionInput,
  },
})
export default class WizardFour extends Vue {
  @State("cart") cart!: Cart;
  @State("user") user!: IUser;
  @State("regions") regions!: Array<Country>;
  @Action setRegions;
  // @State("regions") regions!: Array<Country>;

  autocomplete: any = null;
  contunueHTML = "&nbsp;";
  create_account = true;
  loading = false;
  timeout: any;
  button_loading = false;
  showErrorMsg = false;
  errMsgList: any[] = [];
  isDiffAddress = false;

  componentForm = {
    subpremise: "short_name",
    street_number: "short_name",
    route: "long_name",
    locality: "long_name",
    administrative_area_level_1: "short_name",
    country: "short_name",
    postal_code: "short_name",
    postal_town: "short_name",
    sublocality_level_1: "short_name",
  };

  constructor() {
    super();
  }

  scrollToTop() {
    window.scrollTo(0, 0);
  }

  /**
   * Gets status component
   */
  status() {
    return this.$refs.status as any;
  }

  validateItems() {
    let itemList = this.cart.items;
    for (let i = 0; i < itemList.length; i++) {
      if (itemList[i].coverage == 0 || itemList[i].payment_terms == null) {
        this.$router.push({
          name: "wizard.one",
          query: { redirectMsg: "Please fill in required fields." },
        });
        return;
      }
      if (
        itemList[i].manufacturer == "" ||
        itemList[i].model == "" ||
        itemList[i].serial_number == ""
      ) {
        this.$router.push({
          name: "wizard.three",
          query: { redirectMsg: "Please fill in required fields." },
        });
        return;
      }
    }
  }

  validateZip() {
    return zipValidation(
      this.cart.billing_info.countryId,
      this.cart.billing_info.postcode
    );
  }

  async mounted() {
    this.updateBillingInfo();
    if (Object.keys(this.regions).length === 0) {
      const regions = await countryService.getRegions();
      this.setRegions(regions);
    }

    if (
      this.cart.billing_info.firstname == "" ||
      this.cart.billing_info.lastname == "" ||
      this.cart.billing_info.address == "" ||
      this.cart.billing_info.countryId == "" ||
      this.cart.billing_info.postcode == "" ||
      this.cart.billing_info.city == "" ||
      this.cart.billing_info.region.regionId == 0
    ) {
      this.isDiffAddress = true;
    } else {
      this.isDiffAddress = false;
    }
    this.onChangeIsDiffAddress();
    this.cart.clearIfCompleted();
    if (this.cart.items.length == 0) {
      this.$router.push({ name: "home" });
    }
    this.validateItems();

    this.cart.itemsChanged.on(this.onItemsChanged);

    if (!UserService.isLoggedInQuick()) {
      this.$router.push({ name: "wizard.two" });
    }
    if (typeof google === "undefined") {
      if (!process.env.VUE_APP_GOOGLE_API_KEY) {
        console.error("Google API key is not set.");
        return;
      }
      const script = document.createElement("script");
      script.src = `https://maps.googleapis.com/maps/api/js?key=${process.env.VUE_APP_GOOGLE_API_KEY}&libraries=places`;
      document.head.appendChild(script);
    }
  }

  initAutocomplate() {
    if (typeof google === "undefined") {
      return;
    }
    this.autocomplete = new google.maps.places.Autocomplete(
      this.$refs.autocompleteAddress as HTMLInputElement,
      {
        types: ["geocode"],
        componentRestrictions: { country: ["CA", "US"] },
      }
    );
    this.autocomplete.addListener("place_changed", () => {
      this.getAddressData();
    });
  }

  getAddressData() {
    const place = this.autocomplete.getPlace();
    const addressComponents = place.address_components;

    let streetNumber = "";
    let subpremise = "";
    let city = "";
    let region = "";
    let postalCode = "";
    let countryId = "";
    let street: string[] = [];
    let formattedStreet = "";

    addressComponents.forEach((component) => {
      const addressType = component.types[0];
      if (this.componentForm[addressType]) {
        const val = component[this.componentForm[addressType]];
        if (addressType === "subpremise") {
          subpremise = val;
        } else if (addressType === "street_number") {
          streetNumber = val;
        } else if (addressType === "route") {
          street[1] = val;
        } else if (addressType === "locality") {
          city = val;
        } else if (addressType === "administrative_area_level_1") {
          region = val;
        } else if (addressType === "postal_code") {
          postalCode = val;
        } else if (addressType === "country") {
          countryId = val;
        }
      }
    });

    const regionObj = this.regions[countryId]
      ? this.regions[countryId].find((reg: Country) => reg.short === region)
      : null;

    const regionId = regionObj ? regionObj.id : 0;

    if (subpremise && countryId !== "US") {
      streetNumber = `${subpremise}/${streetNumber}`;
    }

    if (street.length > 0) {
      street[0] = streetNumber;
      formattedStreet = street.join(" ");
      if (countryId === "US" && subpremise !== "") {
        formattedStreet = `${formattedStreet}, ${subpremise}`;
      }
    }

    this.cart.billing_info.address = formattedStreet ? formattedStreet : "";
    this.cart.billing_info.city = city ? city : "";
    this.cart.billing_info.postcode = postalCode ? postalCode : "";
    this.cart.billing_info.countryId = countryId ? countryId : "";

    setTimeout(() => {
      this.cart.billing_info.region.regionId = regionId ? regionId : 0;
      this.cart.billing_info.region.regionCode = region ? region : "";
      this.cart.billing_info.region.region = regionObj ? regionObj.title : "";
    }, 500);
  }

  updateBillingInfo(): void {
    if (this.cart.billing_info.firstname != "") {
      return;
    }
    this.cart.billing_info.fillBillingFromUser(this.user);
    this.cart.persist();
  }

  onItemsChanged() {
    if (this.cart.items.length == 0) {
      this.timeout = setTimeout(this.goHome, 5000);
    }
  }

  beforeDestroy() {
    this.cart.itemsChanged.off(this.onItemsChanged);
  }

  goHome() {
    clearTimeout(this.timeout);
    this.$router.push({ name: "home" });
  }

  removeFormErrors(target: string) {}

  async onSubmit() {
    if (!this.validated) {
      this.showErrorMsg = true;
      this.scrollToTop();
      this.validateExpirationDate();
      this.validateCreditCard();
      return;
    }
    if (this.button_loading) {
      return;
    }

    this.button_loading = true;
    try {
      let quoteIdFromAddingItemstoRemote = await CartService.addCartToRemote(
        this.cart
      );
      if (this.cart.quoteId < 0 || !this.cart.saved) {
        let utm_source = "";
        if (this.cart?.utm_source) {
          //CHECK UTC source always should be one word
          if (!Array.isArray(this.cart.utm_source)) {
            utm_source = this.cart.utm_source;
          }
        }
        const quoteId = await CartService.saveQuote(
          this.cart,
          this.user.id,
          utm_source,
          quoteIdFromAddingItemstoRemote
        );
        if (quoteId > 0) {
          this.cart.saved = true;
          this.cart.quoteId = quoteId;
        }
      }
      this.cart.persist();

      let orderId = null;
      orderId = await CartService.issuePolicy(
        this.cart,
        quoteIdFromAddingItemstoRemote
      );
      if (orderId) {
        this.cart.orderId = orderId; // Assign order_id only if order is placed
      }
      if (this.cart.quoteId > 0) {
        const quoteId = await CartService.updateQuote(
          this.cart.quoteId,
          this.cart.orderId
        );
        if (quoteId > 0) {
          this.cart.saved = true;
          this.cart.quoteId = quoteId;
        }
      }
      this.button_loading = false;
      this.success(this.user.id);
    } catch (error) {
      this.button_loading = false;
      //todo check status
      this.status().error_response(error);
      this.scrollToTop();
    }
  }

  validateExpirationDate() {
    let expDate = this.cart.billing_info.expiration_date;
    if (expDate.toString().length != 4) {
      return false;
    }
    let validDate = true;
    let year = expDate.slice(-2);
    let date = new Date();
    let currentYear = date.getFullYear();
    validDate = validDate && year >= currentYear.toString().slice(-2);

    let month = expDate.substring(0, 2);
    let exp = /^(0[1-9]|1[012])$/g;
    let regex = new RegExp(exp);
    let currentMonth = date.getMonth();

    validDate = validDate && regex.test(month);
    if (year == currentYear.toString().slice(-2)) {
      validDate = validDate && parseInt(month) > currentMonth;
    }
    return validDate;
  }

  validateCreditCard() {
    // getCreditCardNameByNumber('4539578763621486'); // returns 'Visa'
    let validate = isValid(this.cart.billing_info.card_number); // returns true
    switch (
      getCreditCardNameByNumber(
        this.cart.billing_info.card_number
      ).toLowerCase()
    ) {
      case "discover":
      case "amex":
      case "visa":
      case "mastercard":
        break;
      default:
        validate = false;
    }
    return validate;
  }

  validateCVC() {
    let validate = false;
    // getCreditCardNameByNumber('4539578763621486'); // returns 'Visa'
    // let validate = isSecurityCodeValid(
    //   this.cart.billing_info.card_number,
    //   this.cart.billing_info.cvc
    // ); // returns true
    switch (
      getCreditCardNameByNumber(
        this.cart.billing_info.card_number
      ).toLowerCase()
    ) {
      case "amex":
        validate = this.cart.billing_info.cvc.length == 4 ? true : false;
        break;
      case "discover":
      case "mastercard":
      case "visa":
        validate = this.cart.billing_info.cvc.length == 3 ? true : false;
        break;
      default:
        validate = false;
    }
    return validate;
  }

  //https://www.braemoor.co.uk/software/creditcard.shtml

  generateErrMsg() {
    this.errMsgList = [];
    if (
      this.cart.billing_info.address == "" ||
      this.cart.billing_info.firstname == "" ||
      this.cart.billing_info.lastname == "" ||
      this.cart.billing_info.postcode == "" ||
      this.cart.billing_info.city == "" ||
      this.cart.billing_info.name_on_card == "" ||
      this.cart.billing_info.card_number == "" ||
      this.cart.billing_info.cvc == "" ||
      this.cart.billing_info.expiration_date == ""
    ) {
      this.errMsgList.push("Please fill in required fields.");
    }

    if (!this.cart.terms_agree) {
      this.errMsgList.push("Please read and accept the terms.");
    }

    if (this.cart.billing_info.countryId == "") {
      this.errMsgList.push("Please select Country.");
    }

    if (this.cart.billing_info.region.regionId == 0) {
      this.errMsgList.push("Please select State/Province.");
    }

    if (!this.validateExpirationDate()) {
      this.errMsgList.push("Please insert valid expiration date.");
    }
    if (
      !zipValidation(
        this.cart.billing_info.countryId,
        this.cart.billing_info.postcode
      )
    ) {
      this.errMsgList.push("Please insert valid postcode");
    }
    if (!this.validateCreditCard()) {
      this.errMsgList.push("Please insert valid credit card.");
    }
    if (!this.validateCVC()) {
      this.errMsgList.push("Please insert valid CVC.");
    }
  }
  // else{
  //   this.showErrorMsg=true;
  //   window.scrollTo(0,0);
  // }
  // }

  addItems(value: number, items: Array<CartItem>) {
    let ga_items: any = [];
    items.forEach((item, i) => {
      ga_items.push({
        item_id: item.sku,
        item_name: item.name,
        item_category: item.model,
        price: item.total,
        quantity: 1,
      });
    });
    this.$gtag.event("add_to_cart", {
      currency: "USD",
      value: value.toFixed(2),
      items: ga_items,
    });
  }

  purchaseEvent(id, total, items: Array<CartItem>) {
    let ga_items: any = [];
    items.forEach((item, i) => {
      ga_items.push({
        item_id: item.sku,
        item_name: item.name,
        item_category: item.model,
        price: parseFloat(item.total.toFixed(2)),
        quantity: 1,
      });
    });
    this.$gtag.event("purchase", {
      transaction_id: `T_${id}_${Math.floor(Math.random() * 1000000)}`,
      value: parseFloat(total),
      currency: "USD",
      items: ga_items,
    });
  }

  success(transID) {
    this.button_loading = true;
    this.cart.completed = true;
    // this.addItems(this.cart.total, this.cart.items);
    this.purchaseEvent(transID, this.cart.total.toFixed(2), this.cart.items);
    this.cart.clearStorage();
    this.cart.clearCookies();
    this.$router.push({ name: "wizard.end" });
  }

  /**
   * Prepare data for sending to WAG API.
   */
  prepareApiData() {
    let policies: any[] = [];
    let annualAutoReviewIndex = false;
    this.cart.items.forEach((item, index) => {
      let policyItem: any = {
        PolicyItems: [
          {
            CoverageAmount: item.coverage,
            ItemManufacturer: item.manufacturer,
            ItemModel: item.model,
            SerialNumber: item.serial_number,
          },
        ],
        EffectiveDate: item.effectiveDateString,
        ProductSKU: item.sku,
        ProcessingFeeSKU: item.processing_fee_sku,
        PolicyType: item.policyWagType,
        RetailPremium:
          item.payment_terms == CartItemPaymentTerms.Monthly
            ? item.installmentPremium
            : item.due_today.toFixed(2),
        BillToRoleType: app_config.wag_api.order.bill_to_role_type,
        LeadType: app_config.wag_api.order.lead_type,
        State: this.cart.stateValue,
        Interest_Magento_entity_id: null,
        FBO: {
          FirstName: item.customer.first_name,
          LastName: item.customer.last_name,
          Address1: this.cart.billing_info.address,
          Address2: "",
          City: this.cart.billing_info.city,
          State: this.cart.stateValue,
          Zip: this.cart.billing_info.postcode,
          Phone: this.cart.billing_info.telephone,
          Email: "",
        },
      };
      if (annualAutoReviewIndex && item.processing_fee_sku == "PFEE005") {
        let { ProcessingFeeSKU: deleted, ...newState } = policyItem;
        policyItem = newState;
      }
      if (item.processing_fee_sku == "PFEE005") {
        annualAutoReviewIndex = true;
      }
      policies.push(policyItem);
    });

    return {
      APIKey: app_config.wag_api.api_key,
      CustomerID: app_config.wag_api.customer_id,
      PromoCode: app_config.wag_api.promo_code,
      company: app_config.wag_api.order.payment_company,
      Magento_entity_id: Number(this.user.id),
      PaymentRequired: true,
      CreationUser: app_config.wag_api.order.creation_user,
      "": false, // Hilarious
      PaymentMethod: {
        MethodType: app_config.wag_api.order.payment_method_type,
        PaymentAmount: this.cart.total.toFixed(2),
        FirstName: this.cart.billing_info.firstname,
        LastName: this.cart.billing_info.lastname,
        Address1: this.cart.billing_info.address,
        Address2: "",
        City: this.cart.billing_info.city,
        State: this.cart.billing_info.countryId,
        ZipCode: this.cart.billing_info.postcode,
        CreditCard: {
          CardType: this.cart.billing_info.cardTypeShort,
          CardNumber: this.cart.billing_info.card_number,
          CVC: this.cart.billing_info.cvc,
          ExpMonth: this.cart.billing_info.expirationMonth,
          ExpYear: this.cart.billing_info.expirationYear,
        },
      },
      Policies: policies,
      RequestOptions: {
        Src_Ref_Num: "",
        Request_Type: "",
        Store_ID: "dgray",
        SalesAssociate: "",
        Env_Ind: "live",
      },
    };
  }

  get supportedCountries() {
    return supported_countries;
  }

  countryChanged() {
    // this.cart.billing_info.regionId = 0;
  }

  get currentDay() {
    let date = new Date().getDate();
    return date + this.nth(date);
  }

  get currentMonthDay() {
    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    let date = new Date();
    let day = date.getDate() + this.nth(date.getDate());
    let month = months[date.getMonth()];

    return month + " " + day;
  }

  nth = function (d) {
    if (d > 3 && d < 21) return "th";
    switch (d % 10) {
      case 1:
        return "st";
      case 2:
        return "nd";
      case 3:
        return "rd";
      default:
        return "th";
    }
  };

  get validated() {
    this.generateErrMsg();
    let validate = true;
    validate =
      validate &&
      this.cart.billing_info.address != "" &&
      this.cart.billing_info.firstname != "" &&
      this.cart.billing_info.lastname != "" &&
      this.cart.billing_info.countryId != "" &&
      this.cart.billing_info.postcode != "" &&
      this.cart.billing_info.city != "" &&
      this.cart.billing_info.name_on_card != "" &&
      this.cart.billing_info.card_number != "" &&
      this.cart.billing_info.cvc != "" &&
      this.cart.billing_info.expiration_date != "" &&
      this.cart.billing_info.region.regionId != 0 &&
      this.cart.terms_agree &&
      this.validateExpirationDate() &&
      this.validateCreditCard() &&
      this.validateCVC();

    return validate;
  }

  showValidationClass(value: string | number) {
    return (value == "" || value == 0) && this.showErrorMsg;
  }

  get emptyCountry() {
    return new Country();
  }

  get displayAddress() {
    let temp = this.cart.billing_info.address;
    if (this.cart.billing_info.city && this.cart.billing_info.address) {
      temp = temp + " | " + this.cart.billing_info.city;
      if (this.cart.billing_info.region.regionId) {
        temp = temp + ", " + this.cart.billing_info.region.region;
        if (this.cart.billing_info.postcode) {
          temp = temp + " " + this.cart.billing_info.postcode;
        }
      }
    }

    return temp;
  }

  onChangeIsDiffAddress() {
    if (this.isDiffAddress) {
      this.cart.billing_info.firstname = "";
      this.cart.billing_info.lastname = "";
      this.cart.billing_info.address = "";
      this.cart.billing_info.countryId = "";
      this.cart.billing_info.postcode = "";
      this.cart.billing_info.city = "";
      this.cart.billing_info.region.regionId = 0;
      this.cart.billing_info.telephone = "12345";

      this.$nextTick(() => {
        if (typeof google === "undefined") {
          return;
        }
        this.initAutocomplate();
      });
    } else {
      this.cart.billing_info.fillBillingFromUser(this.user);
    }
  }

  get regionsFromSelectedCountry() {
    return this.regions[this.cart.billing_info.countryId];
  }

  get isCanadaCountry() {
    return this.cart.billing_info.countryId === "CA";
  }
}
